import NotificationActions from '../../../actions/NotificationActions';
import PopupActions from '../../../actions/PopupActions';
import RoutingActions from '../../../actions/RoutingActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PopupStore from '../../../stores/PopupStore';
import PosCartStore from '../../../stores/PosCartStore';

import PosCartActions from '../../../actions/PosCartActions';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import Utils from '../../../utils/Utils';

import DateTime from '../../form/DateTime.react';
import PrintActions from '../../../actions/PrintActions';

class Delivery extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible         : false,

            guest           : false,
            shipmentId      : false,

            title           : '',

            drivers         : [],
            selectedDriver  : '',
            selectedSecondaryDriver: '',
            cars            : [],
            selectedCar     : '',
            selectedAddress : '',


            departureDate   : moment(new Date()).format('YYYY-MM-DD'),
            departureTime   : '12:00',
            arrivalDate     : moment(new Date()).format('YYYY-MM-DD'),
            arrivalTime     : '21:00',

            comments        : '',
            directions      : '',

            manifestId      : 0,

            loading         : false,
            completed       : false,
            externalDeliveryId: null
        };

        this.onPopupStoreChange = this.onPopupStoreChange.bind(this);
        this.loadManifest = this.loadManifest.bind(this);
        this.printManifest = this.printManifest.bind(this);
        this.saveManifest = this.saveManifest.bind(this);
        this.completeOrder = this.completeOrder.bind(this);
        this.readyForDelivery = this.readyForDelivery.bind(this);
        this.openMetrcBypass = this.openMetrcBypass.bind(this);
        this.getDirections = this.getDirections.bind(this);
    }

    componentDidMount() {
        PopupStore.addChangeListener(this.onPopupStoreChange);

    }

    componentWillUnmount() {
        PopupStore.removeChangeListener(this.onPopupStoreChange);
    }

    getDirections() {

        var address = this.state.guest.address;
        const addressBook = this.state.guest.AddressBook;

        if (addressBook) {
            for (var i = 0; i < addressBook.length; i++) {
                if (this.state.selectedAddress == addressBook[i].AddressId) {
                    address = addressBook[i];
                }
            }
        }

        AjaxPromises.POST(PosEndPoints.GET_DIRECTIONS_BY_ADDR, UserStore.getApiData({
            ShipmentId: this.state.guest.ShipmentId,
            DestinationAddress1: address.street,
            DestinationCity: address.city,
            DestinationState: address.state,
            DestinationPostalCode: address.postal_code,
        })).then(res => {
            var directions = res.Data;
            if(directions) {
                this.setState({ directions });
            }

            if(!res.Result) {
                NotificationActions.error(res.Message);
            }
        })
    }

    onPopupStoreChange(data) { // {page, data, guest}
        if (data.page === 'delivery')
            this.setState({
                guest : data.guest,
                shipmentId : data.shipmentId,
                loading : false,
            }, () => {
                this.loadManifest();
            });
    }

    openMetrcBypass() {
        this.setState({ visible: false }, () => {
            PopupActions.open('bypassStateSystem', { shipmentId: this.state.shipmentId }, this.state.guest);
        });
    }

    loadManifest() {

        var formData = UserStore.getApiData();
        formData.TransId = this.state.shipmentId;

        RSVP.all([
            AjaxPromises.POST(PosEndPoints.LOAD_DRIVERS, UserStore.getApiData()),
            AjaxPromises.POST(PosEndPoints.LOAD_CARS, UserStore.getApiData()),
            AjaxPromises.POST(PosEndPoints.GET_MANIFEST, formData)
        ]).then(res => {
            var manifestId = res[2].Data[0].ManifestId;
            var manifestData = res[2].Data[0] || {};

            this.setState({
                visible: true,
                drivers: res[0].Data,
                cars: res[1].Data,
                manifestId: manifestId,
                title: manifestId !== 0 ? res[2].Data[0].Title || '' : '',
                selectedDriver: manifestId !== 0 && res[2].Data[0].DriverId ? res[2].Data[0].DriverId : '',
                selectedSecondaryDriver: manifestId !== 0 && res[2].Data[0].SecondaryDriverId ? res[2].Data[0].SecondaryDriverId : '',
                selectedCar: manifestId !== 0 && res[2].Data[0].CarId ? res[2].Data[0].CarId : '',
                selectedAddress: manifestId !== 0 ? res[2].Data[0].DeliveryAddressId : '',
                departureDate: manifestId !== 0 && res[2].Data[0].DepartureDate ? moment(res[2].Data[0].DepartureDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
                departureTime: manifestId !== 0 && res[2].Data[0].DepartureDate ? moment(res[2].Data[0].DepartureDate).format('HH:mm') : '12:00',
                arrivalDate: manifestId !== 0 && res[2].Data[0].ClosedDate ? moment(res[2].Data[0].ClosedDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
                arrivalTime: manifestId !== 0 && res[2].Data[0].ClosedDate ? moment(res[2].Data[0].ClosedDate).format('HH:mm') : '21:00',
                comments: manifestId !== 0 ? res[2].Data[0].Comments : '',
                directions: manifestId !== 0 ? res[2].Data[0].RouteDetails : '',
                externalDeliveryId:  manifestData.ExternalDeliveryId,
                METRCStateCode: manifestData.METRCStateCode,
            });
        });
    }

    async printManifest() {
        var shipmentId = this.state.shipmentId;

        var data = await AjaxPromises.POST('api/v2/manifest/print-manifest', UserStore.getApiData({ PosId: shipmentId }), 'Manifest failed to generate');

        Utils.openPDFInWindow(data.Data, `PrintedManifest-${shipmentId}.pdf`);

        NotificationActions.success('Manifest generated');
    }

    saveManifest(complete) {
        if (!this.isValid() || this.state.loading) {
            return;
        }

        if (!Number(this.state.selectedAddress)) {
            //The AddressId is null for the regular address on guest
            //This check helps to avoid a typing error on the option element while still sending the null value on a SAVE
            this.setState({ selectedAddress: null });
        }

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(PosEndPoints.UPDATE_MANIFEST, UserStore.getApiData({
                Title      : this.state.title,
                CarId      : this.state.selectedCar,
                DriverId   : this.state.selectedDriver,
                SecondaryDriverId   : this.state.selectedSecondaryDriver === 0 ? null : this.state.selectedSecondaryDriver,
                Departs    : moment(this.state.departureDate).format('MM/DD/YYYY')+' '+this.state.departureTime+':00',
                Arrives    : moment(this.state.arrivalDate).format('MM/DD/YYYY')+' '+this.state.arrivalTime+':00',
                Comments   : this.state.comments,
                Directions : this.state.directions,
                TransId    : this.state.shipmentId,
                AddressId  : this.state.selectedAddress,
            })).then(res => {
                NotificationActions.addNotification({
                    type : res.Result ? 'success' : 'error',
                    body : res.Result ? 'Manifest saved' : 'Manifest failed to save'
                });

                if (res.Result) {
                    if (complete) {
                        this.completeOrder();
                    } else {
                        this.setState({ loading : false }, () => {
                            this.loadManifest();
                        });
                    }
                } else {
                    this.setState({ loading : false });
                }
            }).then(() => {
                PosCartActions.loadUserCart(this.state.guest.Guest_id, this.state.guest.ShipmentId);
            });
        })
    }

    readyForDelivery() {
        if(this.state.loading) {
            return;
        }

        this.setState({ loading: true });
        AjaxPromises.POST(PosEndPoints.READY_FOR_DELIVERY, UserStore.getApiData({
            ShipmentId    : this.state.shipmentId,
        })).then(res => {
            var message = 'Order Ready for Delivery';
            if(!res.Result) {
                message = 'Order failed to mark ready for delivery.';
                if(!!res.Message) {
                    message += ' ' + res.Message;
                }
                if(!!res.IntegrationMessage) {
                    message += ' ' + res.IntegrationMessage;
                }
            }
            else {
                var externalDeliveryId = res.Data.DeliveryManifest.ExternalDeliveryId;
                this.setState({ externalDeliveryId });
            }
            NotificationActions.addNotification({
                type : res.Result ? 'success' : 'error',
                body : message,
            });
        })
        .finally(() => {
            this.setState({ loading: false });
        });
    }

    completeOrder() {
        return;
        var self = this;

        var guest = this.state.guest;
        var cart  = PosCartStore.getCartSummary();
        var user  = UserStore.getState().user;

        var totalItems       = 0;
        var discountAmt      = 0;
        var taxAmt           = 0;

        // for (var i=0; i<cart.length; i++) {
        //     totalItems  += cart[i].QtyAllocated;
        //     discountAmt += cart[i].DiscountAmt;
        //     taxAmt      += cart[i].TaxAmt;
        //     subtotal    += cart[i].TotalCost;
        // }

        var test = UserStore.getApiData({
            ShipmentId     : guest.ShipmentId,
            MJStateIDNo    : guest.MJStateIDNo,
            TotalItems     : cart.totalItems,
            DiscountAmt    : Math.abs(cart.discount.flt),
            TaxAmt         : cart.tax.flt,
            CheckPaid      : 0,
            CCPaid         : 0,
            UserId         : user.userId,
            TerminalId     : UserStore.getState().selectedRegister.id,
            DebitPaid      : 0,
            TotalCharges   : cart.roundedDown.flt,
            Paidamt        : cart.roundedDown.flt,
            DueCustomer    : 0,



            TransType      : 'Cash',
            TransId        : '',
            SubTotal       : cart.subTotal.flt,

            NetAmt         : 0,
            TaxRt          : 0,
        });

        return;
        AjaxPromises.POST(EndPoints.CHECKOUT, UserStore.getApiData({
            ShipmentId     : guest.ShipmentId,
            MJStateIDNo    : guest.MJStateIDNo,
            TotalItems     : cart.totalItems,
            DiscountAmt    : Math.abs(cart.discount.flt),
            TaxAmt         : cart.tax.flt,
            CheckPaid      : 0,
            CCPaid         : 0,
            UserId         : user.userId,
            TerminalId     : UserStore.getState().selectedRegister.id,
            DebitPaid      : 0,
            TotalCharges   : cart.roundedDown.flt,
            Paidamt        : cart.roundedDown.flt,
            DueCustomer    : 0,



            TransType      : 'Cash',
            TransId        : '',
            SubTotal       : cart.subTotal.flt,

            NetAmt         : 0,
            TaxRt          : 0,
        })).then(res => {
            if (res.Data && res.Data[0].ResultId === 1) {
                self.setState({
                    completed : true
                });
            } else {
                NotificationActions.addNotification({
                    type : 'error',
                    body : res.Message
                });

                self.setState({
                    loading : false
                })
            }
        })
    }

    isValid() {
        const { 
            title,
            selectedDriver,
            selectedCar,
            departureDate,
            departureTime,
            arrivalDate,
            arrivalTime,
        } = this.state;

        if (title.length < 1)
            return false;

        if (!selectedDriver || !selectedCar) {
            return false;
        }

        if (!moment(moment(departureDate).format('MM/DD/YYYY')+' '+departureTime+':00').isValid())
            return false;

        if (!moment(moment(arrivalDate).format('MM/DD/YYYY')+' '+arrivalTime+':00').isValid())
            return false;

        return true;
    }

    render() {
        if (!this.state.visible)
            return null;

        var guest = this.state.guest;
        var valid = this.isValid();
        let selectedLocation = UserStore.getState().selectedLocation;

        let cartSummary = PosCartStore.getCartSummary();
        let payload = {
            receiptId: guest.ShipmentId,
            subTotal: cartSummary.subTotal.flt,
            total: cartSummary.total.flt,
        }

        var addressBook = guest.AddressBook;

        return (
            <div
                className={'popup popup__transparent'}>

                <div className='popup__content' style={{  }}>

                    <div className='popup-header'>
                        Delivery Options

                        <div
                            className='popup-close'
                            onClick={() => {
                                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                                this.setState({
                                    visible : false,
                                    guest : false,
                                    shipmentId : false,
                                }, () => {
                                    if (this.state.completed)
                                        RoutingActions.updateRoute('guest-list');
                                });
                            }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='delivery-options' style={{ overflowY: 'scroll' }}>
                        <div className='delivery-options__label'>
                            Title
                        </div>

                        <input
                            type='text'
                            placeholder='Title'
                            value={this.state.title}
                            onChange={(e) => { this.setState({ title : e.target.value }); }} />

                        <div className='delivery-options__label'>
                            Driver
                        </div>

                        <select
                            value={this.state.selectedDriver}
                            onChange={(e) => { this.setState({ selectedDriver : e.target.value }); }}>

                            <option
                                value=''
                                disabled>

                                Select Driver
                            </option>

                            { this.state.drivers.map((data, i) => {
                                return (
                                    <option
                                        value={data.Id}
                                        key={'data.driver'+i}>

                                        {data.Name}
                                    </option>
                                );
                            })}
                        </select>

                        <div className='delivery-options__label'>
                            Secondary Driver
                        </div>

                        <select
                            value={this.state.selectedSecondaryDriver}
                            onChange={(e) => { this.setState({ selectedSecondaryDriver : e.target.value }); }}>

                            <option
                                value=''
                                disabled>

                                Select Secondary Driver
                            </option>

                            { this.state.drivers.map((data, i) => {
                                return (
                                    <option
                                        value={data.Id}
                                        key={'data.driver'+i}>

                                        {data.Name}
                                    </option>
                                );
                            })}
                        </select>

                        <div className='delivery-options__label'>
                            Car
                        </div>

                        <select
                            value={this.state.selectedCar}
                            onChange={(e) => { this.setState({ selectedCar : e.target.value }); }}>

                            <option
                                value=''
                                disabled>

                                Select Car
                            </option>

                            { this.state.cars.map((data, i) => {
                                return (
                                    <option
                                        value={data.id}
                                        key={'data.car'+i}>

                                        {data.CarModel} - {data.CarLicId}
                                    </option>
                                );
                            })}
                        </select>

                        <div className='delivery-options__label'>
                            Delivery Address
                        </div>

                        <select
                            value={this.state.selectedAddress}
                            onChange={(e) => { this.setState({ selectedAddress: e.target.value }); }}>

                            <option
                                value=''
                                disabled>

                                Select Address
                            </option>

                            <option
                                value={guest.address.street}
                                key={'guest.address.street'}>

                                {guest.address.street} {guest.address.city}, {guest.address.state}
                            </option>

                            {addressBook.map((data, i) => {
                                return (
                                    <option
                                        value={data.AddressId}
                                        key={'data.street' + i}>

                                        {data.street} {data.city}, {data.state}
                                    </option>
                                );
                            })}
                        </select>

                        <div className='delivery-options__label'>
                            Departure Date
                        </div>

                        <DateTime
                            selectDate={(date) => { this.setState({ departureDate : date }); }}
                            selectTime={(time) => { this.setState({ departureTime : time }); }}
                            allowPastDate={true}
                            date={this.state.departureDate}
                            time={this.state.departureTime}
                            top='50%'
                            left='50%' />

                        <div className='delivery-options__label'>
                            Arrival Date
                        </div>

                        <DateTime
                            selectDate={(date) => { this.setState({ arrivalDate : date }); }}
                            selectTime={(time) => { this.setState({ arrivalTime : time }); }}
                            allowPastDate={true}
                            date={this.state.arrivalDate}
                            time={this.state.arrivalTime}
                            top='50%'
                            left='50%' />

                        <div className='delivery-options__label'>
                            Comments
                        </div>

                        <input
                            type='text'
                            placeholder='Comments'
                            value={this.state.comments}
                            onChange={(e) => { this.setState({ comments : e.target.value }); }} />

                        <div className='delivery-options__label'>
                            Directions
                        </div>

                        <textarea
                            placeholder='Directions'
                            className='delivery-options__high'
                            value={this.state.directions}
                            onChange={(e) => { this.setState({ directions : e.target.value }); }} />

                        {
                        selectedLocation.UseMETRC &&
                        <div className='delivery-options__label' style={{ marginBottom: 15, width: '100%' }}>
                            <div>METRC Delivery ID: { this.state.externalDeliveryId }</div>
                            {
                                !!this.state.METRCStateCode &&
                                <div>
                                    <a href={'https://'+this.state.METRCStateCode+'.metrc.com/reports/sales/deliveries/manifest?id='+this.state.externalDeliveryId} target="_blank">
                                        Open METRC Manifest
                                    </a><i>(Requires Login)</i>
                                </div>  
                            }
                        </div>
                        }
                        <div>
                            <div style={{ height: 50 }}>
                                <div
                                    className={'btn-green delivery-options__save '+(!valid ? 'btn-green__disabled' : '')}
                                    onClick={this.saveManifest.bind(this, false)}
                                    style={{ position: 'absolute', left: 0}}                            
                                >
                                    Save
                                </div>
                                <div
                                    className={'btn-green delivery-options__save pull-right'}
                                    onClick={this.readyForDelivery}
                                    style={{ position: 'absolute', right: 20}}
                                >
                                    {
                                        this.state.loading ?
                                        <i className='fa fa-spinner fa-pulse' /> :
                                        'Ready for Delivery'
                                    }
                                </div>                        
                            </div>
                            <div style={{ height:50 }}>
                                <div
                                    className={'btn-green '+(this.state.manifestId === 0 ? 'btn-green__disabled' : '')}
                                    onClick={this.printManifest}
                                    style={{ position: 'absolute', left: 20}}                            
                                >

                                    Print Manifest
                                </div>

                                <div
                                    className={'btn-green delivery-options__save '}
                                    onClick={() => { PrintActions.printPreCheckoutReceipt(payload, true); }}
                                    style={{ marginLeft: 5, position: 'absolute', right: 20}}
                                >

                                    Print Receipt
                                </div>                        
                            </div>
                            <div style={{ height: 50 }}>
                                <div
                                    // should be disabled/hidden based on user permissions?
                                    className='btn-green delivery-options__save'
                                    onClick={this.openMetrcBypass}
                                    style={{ position: 'absolute', left: 0}}
                                >
                                    Bypass State System
                                </div>

                                <div
                                    className={'btn-green'}
                                    onClick={this.getDirections}
                                    style={{ position: 'absolute', right: 20}}                            
                                >
                                    Get Directions
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Delivery;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/delivery/Delivery.react.jsx